import { Component, OnInit } from '@angular/core';
import { AlertService } from '../alert.service';
import { interval } from 'rxjs';
import { TrackingService } from '../tracking.service';
import { CustomerService } from '../customer.service';

@Component({
  selector: 'pv-alert-toolbar',
  templateUrl: './alert-toolbar.component.html',
  styleUrls: ['./alert-toolbar.component.scss']
})
export class AlertToolbarComponent implements OnInit {
  alert;
  alerts = [];

  constructor(
    private alertService: AlertService,
    private trackingService: TrackingService,
    private customerService: CustomerService
  ) { }

  ngOnInit() {
    this.customerService.loginSubject.subscribe(login => {
      if (login.is_wholesale) {
        this.alerts = [];
      }
    })

    this.alertService.getAlerts().subscribe(alerts => {
      if (this.customerService.checkoutDTO.customer.is_wholesale) {
        return;
      }
      this.alerts = alerts
      this.alert = alerts.length ? alerts[0] : null
    })

    interval(10 * 1000)
    .subscribe(x => {
      if (this.alerts.length > 1) {
        const index = this.alerts.indexOf(this.alert)
        this.alert = this.alerts[(index + 1) % this.alerts.length]
      }
    })
  }


  gaTrack(alert)
  {
    this.trackingService.event('select_promotion', this.customerService.account.id, { 'promotion_name': alert.text });
  }
}
